module.exports = __webpack_public_path__ + "dist/img/website.90eb4060.webp";